import helper from "./helper";

let getPassOrderUrlWithParameters = helper.getPassOrderUrlWithParameters

export default {
    BASE: {
        COMPLETED:
            (id, gets = null) => getPassOrderUrlWithParameters(
                "base|requests-upload-complete",
                "upload_complete",
                {id: id},
                gets
            ),
        DOWNLOAD: (id, gets = null) => getPassOrderUrlWithParameters(
            "base|requests-download",
            "download",
            {id: id},
            gets
        )
    }
}
